var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "club-base-layout" }, [
    _c("div", { class: _vm.baseLayoutContentClassList }, [
      _c(
        "div",
        {
          staticClass: "club-base-layout__body justify-center",
          class: _vm.useCenteredSlotData ? "align-center" : "",
        },
        [_vm._t("club-base-layout-body")],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "club-base-layout__footer" },
        [
          _vm._t("club-base-layout-prepend-footer"),
          _vm._v(" "),
          _vm._t("club-base-layout-footer", function () {
            return [
              _c(
                "div",
                { staticClass: "text-body-2 text-info--text text-center" },
                [
                  _vm._v(
                    "\n          Если возникли вопросы, звоните\n          "
                  ),
                  _vm.isMobileDevice ? _c("br") : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "text-body-2 text-info--text",
                      attrs: { href: "tel:88007073129" },
                    },
                    [_vm._v("8 (800) 707-31-29")]
                  ),
                  _vm._v("\n          — поможем разобраться\n        "),
                ]
              ),
            ]
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }